import { MEDIA_PREFIX } from '@/constants/apiPrefixes'

export const getLinkByEvent = fileName => `${process.env.VUE_APP_BASE_S3_URL}/${window.eventDataID}/${fileName}`
export const getLinkByFileId = fileName => `${process.env.VUE_APP_BASE_API_URL}${MEDIA_PREFIX}/download/${fileName}`
export const getLinkByFileName = (...components) => getLinkByEvent(components.join('/'))
